import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import WgptAuditTrail from './Index.vue';
import Wrapper from './Wrapper.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/wgpt-audit-trail'),
      meta: {
        featureFlag: FEATURE_FLAGS.WGPT_AUDIT_TRAIL,
        permissions: ['administrator'],
      },
      component: Wrapper,
      children: [
        {
          path: '',
          name: 'wgpt_audit_trail',
          redirect: 'list',
          meta: {
            featureFlag: FEATURE_FLAGS.WGPT_AUDIT_TRAIL,
            permissions: ['administrator'],
          },
        },
        {
          path: 'list',
          name: 'wgpt_audit_trail_list',
          component: WgptAuditTrail,
          meta: {
            featureFlag: FEATURE_FLAGS.WGPT_AUDIT_TRAIL,
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
